module.exports = __webpack_public_path__ + "static/media/zhifubaoxiao.7d507a67.png";